<template>
  <custom-dialog
    :openDialog="isOpen"
    :widthDialog="'700px'"
    :classDialog="''"
    @closeDialog="$emit('closeDialog')"
    @closed="$emit('closed')"
  >
    <template #body>
      <h3 class="dialogTitle">{{ dialogTitle }}</h3>
      <el-form
        :model="form"
        :rules="rules"
        ref="form"
        label-position="right"
        label-width="120px"
        class="padding-bottom-10 margin-bottom-10"
      >
        <el-row :gutter="12" type="flex" class="">
          <el-col :span="24" class="margin-bottom-10">
            <el-form-item label="Tên sổ văn bản:" prop="bookName">
              <el-input
                v-model="form.bookName"
                class="style-fullWidth input-border__bottom input-border__radius__0 input-count__bottom"
                placeholder="-"
                maxlength="100"
                show-word-limit
              ></el-input>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row
          :gutter="12"
          type="flex"
          v-if="bookType === BOOK_TYPE.VB_DI"
          class=""
        >
          <el-col :span="24">
            <el-form-item label="Ký hiệu văn bản:" prop="prefix">
              <el-input
                v-model="form.prefix"
                class="input-border__bottom input-border__radius__0 style-fullWidth"
                placeholder="-"
                maxlength="50"
              ></el-input>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row :gutter="12" type="flex">
          <el-col :span="24">
            <el-form-item label="Số sổ hiện tại" prop="bookCurrentNumber">
              <el-input-number
                :min="0"
                :step="1"
                :precision="0"
                v-model="form.bookCurrentNumber"
                v-focus.native
                size="mini"
                class=""
                placeholder="-"
              ></el-input-number>
            </el-form-item>
          </el-col>
        </el-row>
      </el-form>
    </template>
    <template #footer>
      <div class="flex-row flex__right form-button__action">
        <el-button class="dialogBtnPrimary" @click="save">
          <i class="fas fa-save"></i>&nbsp; Tạo mới
        </el-button>
        <el-button
          class="btn__cancel btn-none__border"
          @click="$emit('closeDialog')"
        >
          <i class="fas fa-times"></i>
          &nbsp;Hủy
        </el-button>
      </div>
    </template>
  </custom-dialog>
</template>

<script>
  import bookService from "../../services/bookService";
  import handleRequestErrorMixin from "../handleRequestErrorMixin";
  import constants from "../../constants";
  import utils from "../../services/utils";
  import CustomDialog from "../common/custom-dialog";

  export default {
    name: "vb-book-create-dialog",
    mixins: [handleRequestErrorMixin],
    components: {
      CustomDialog
    },
    props: ["isOpen", "bookType"],
    data() {
      return {
        BOOK_TYPE: constants.BOOK_TYPE,
        form: {
          bookName: null,
          bookCurrentNumber: 0,
          prefix: null
        },
        rules: {
          bookName: null,
          prefix: null,
          bookCurrentNumber: null
        },
        dialogTitle: null,
      };
    },


    created() {
      this.initComponent();
    },

    methods: {

      buildDialogTitle() {
        switch (this.bookType) {
          case constants.BOOK_TYPE.VB_DI:
            return this.dialogTitle = 'Tạo mới sổ đi';
          case constants.BOOK_TYPE.VB_DEN:
            return this.dialogTitle = 'Tạo mới sổ đến';
          default:
            return null;
        }
      },

      initComponent() {
        this.initValidationRules();
        this.buildDialogTitle();
      },

      initValidationRules() {
        this.rules.bookName = [utils.buildRequiredValidationConstrains()];
        this.rules.bookCurrentNumber = [
          utils.buildRequiredValidationConstrains()
        ];
        this.rules.prefix =
          this.bookType === constants.BOOK_TYPE.VB_DI
            ? [utils.buildRequiredValidationConstrains()]
            : null;
      },

      validateForm() {
        return utils.validateFormCommon(this.$refs.form, this.$message);
      },

      save() {
        this.validateForm().then(() => this.save_());
      },

      convertToSubmitForm() {
        return {
          bookName: this.form.bookName,
          prefix: this.form.prefix,
          bookCurrentNumber: this.form.bookCurrentNumber || 0,
          bookType: this.bookType
        };
      },

      save_() {
        let submitForm = this.convertToSubmitForm();
        return bookService
          .add(submitForm)
          .then(response => {
            this.$message({message: "Tạo mới sổ thành công", type: "success"});
            this.$emit("success", {vbBook: response.data});
          })
          .catch(error => this.commonHandleRequestError(error));
      }
    }
  };
</script>

<style scoped></style>



// WEBPACK FOOTER //
// src/views/book/vb-book-create-dialog.vue